import { useSelector, useDispatch } from 'react-redux';
import { useCallback } from 'react';
import { fetchRewards } from '../store/rewardsSlice';

export const useRewards = () => {
  const dispatch = useDispatch();
  const rewards = useSelector((state) => state.rewards);
  
  const loadRewards = useCallback((rewardSet = 'base') => {
    
    // Просто диспатчим - без кэширования
    dispatch(fetchRewards(rewardSet));
  }, [dispatch, rewards.rewards.length, rewards.isLoading]);
  
  return {
    ...rewards,
    loadRewards,
  };
};
